import React 			from 'react';
import ReactDOM 		from 'react-dom';
import moment 			from 'moment';

import BLComponent		from '../../core/_BLComponent.jsx';

import CrowdNavigation 	from '../common/_CrowdNavigation.jsx';
import SeriesInternalNav from '../common/_SeriesInternalNav.jsx';
import BDPSubmissionCard from '../common/_BDPSubmissionCard.jsx';

import CrowdSubmissionResults from './_CrowdSubmissionResults.jsx';
import TimelineContent from './_TimelineContent.jsx';
import BDPHeader from '../common/_BDPHeader.jsx';
import {bdpDateFormat, bdpDateFormatShort, bdpDateFormatLong} from './../common/_BDPUtilities.jsx';


export default class CrowdSeriesFinalists extends BLComponent {
	constructor (props, context) {
		super(props, context);

		this.state = {
			searchQuery: blapp.util.getUrlVar('s') ? blapp.util.getUrlVar('s') : '',
			resultSearchQuery: blapp.util.getUrlVar('s') ? blapp.util.getUrlVar('s') : '',
			postsPerPage: 24,
			sortMethod: -1,
			sortDirection: 1,
			submissions: [],
			categoryFilter: [],
			filterVoted: 0,
			showFilters: false
		};

		this.finalists 			= blapp.models.get('submissions_finalists') || [];
		this.series 				= blapp.models.get('listSeries') || [];
		this.seriesNumber 	= parseInt(blapp.util.getUrlInfo(window.location.href).path.split('/')[3].split('-')[1]); 
		this.seriesContent 	= this.series[this.series.findIndex(series => series.idSeries == this.seriesNumber)];
	}

	render() {
		return (
			<React.Fragment>
				{!blapp.config.isDesktopMode() ? <CrowdNavigation page={1}/> : null}
				<BDPHeader series>
					{this.seriesNumber == 5 &&
						<article className="notification notification--studio notification--warning l-margin-y--xl">
							<h1 className="text--small-title text--bold">More Series 5 Sets? You Got It! </h1>
							<p>The love for Series 5 has blown us away! We know it’s tough when sets sell out before you can get your hands on them, so we teamed up with our manufacturing friends to make more sets available. This may not be the case for future series, so don't miss your chance to get in on the fun. </p>
						</article>
					}
				</BDPHeader>
				<SeriesInternalNav classes="bdp-series-main__series-nav--staggered bdp-series-main__series-nav-landing"/>
				<div className="main">
					<div className="main__content">
						<div className="edge-to-edge-container bdp-series-main__finalist-container bdp-series-main__finalist-container--series-past">
							<div className="edge-to-edge-container__internal">
								{this.renderRecentSeriesWinners()}
							</div>
						</div>
						<section className={`bdp-series-timeline__container bdp-series-timeline__container--series-past`}>
							<TimelineContent type="past"/>
						</section>
						<div className="edge-to-edge-container bdp-series-main__finalist-past-feed">
							<div className="edge-to-edge-container__internal bdp-series-main__finalist-drawer">
								<h2 className="text--bold text--small-title">Designs not chosen for crowdfunding</h2>
								<CrowdSubmissionResults classes="bdp-series-main__finalist-drawer-content"/>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}

	renderRecentSeriesWinners() {
		const finalistCards = this.finalists.data.submissions.map(submission => <BDPSubmissionCard data={submission} key={submission.idSubmission} hasVoting={true} classes="bdp-series-submissions__card"/>);
		const crowdfundingDate = bdpDateFormatLong(this.seriesContent.udtCrowdFundingStart);

		return (
			<section className="bdp-series-past__finalists">
				<h2 className="bdp-series-main__announcement-title l-margin-bottom--sm">Our five {this.seriesContent.strName} finalists!</h2>
				<p className="bdp-series-main__announcement-intro bdp-series-main__announcement-intro--finalists-landing">These designs are chosen for Crowdfunding on {crowdfundingDate} Pacific time.</p>
				<section className="bdp-series-submissions__card-container bdp-series-submissions__card-container--finalists-landing">
					{finalistCards}
				</section>
			</section>
		);
	}
};